import { CopyOutlined } from '@ant-design/icons';
import { Button, Pagination, Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
// import { Select } from 'antd';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { decodeJWT, transactionList } from '../../services/api';
import useCopyToClipboard from '../../utils/useCopyToClipboard';
import ShortenText from '../../utils/ShortenText';
import moment from 'moment';
import CustomSelectBox from './CustomSelect';
import InputField from '../updated/shared/TextField';
// import GenericButton from '../updated/shared/Button';
import { useTheme } from '@mui/material';

// const { Option } = Select;
interface DataType {
  to: string;
  txId: string;
  key: string;
  time: string;
  type: string;
  benificaryAddress: string;
  wallet: string;
  currencyRef: string;
  status: string;
  amount: number;
  destination: string;
  txid: string;
  notes?: string;
}

const BSTransactionHistoryTable: React.FC<{
  onDataChange?: (data: any[]) => void;
}> = ({ onDataChange }) => {
  const [selection, setSelection] = useState({
    type: 'all',
    asset: 'all',
    status: 'all',
    time: 'all',
    transactionHash: '',
  });
  const [txList, setTxList] = useState() as any;
  // const [options, setOptions] = useState<{ value: string; label: string }[]>(
  //   []
  // );
  const theme = useTheme();
  const [txListFilter, setTxListFilter] = useState() as any;
  const pageSize = 10;
  const [current, setCurrent] = useState(1);
  const [, copy] = useCopyToClipboard();
  const [transactionTypes, setTransactionTypes] = useState<string[]>([]);
  const [assets, setAssets] = useState<string[]>([]);
  // const [valueInput, setValueInput] = useState('');

  // const formatBeneficiaryAddress0 = (address: string) => {
  //   try {
  //     const parsedAddress = JSON.parse(address);
  //     const formattedAddress = (
  //       <>
  //         <div>
  //           <strong>Name:</strong> {parsedAddress.beneficiaryName || 'NA'}
  //         </div>
  //         <div>
  //           <strong>Account No:</strong> {parsedAddress.accountNumber || 'NA'}
  //         </div>
  //         <div>
  //           <strong>Bank: </strong>
  //           {parsedAddress.bankName || 'NA'}
  //         </div>
  //         <div>
  //           <strong>SWIFT:</strong> {parsedAddress.swiftCode || 'NA'}
  //         </div>
  //         <div>
  //           <strong>Routing Number: </strong>
  //           {parsedAddress.routingNumber || 'NA'}
  //         </div>
  //         <div>
  //           <strong>Address: </strong>
  //           {`${parsedAddress.addressLine1 || 'NA'}, ${
  //             parsedAddress.city || 'NA'
  //           }, ${parsedAddress.state || 'NA'}, ${
  //             parsedAddress.country || 'NA'
  //           }, ZIP: ${parsedAddress.zipCode || 'NA'}`}
  //         </div>
  //       </>
  //     );

  //     return formattedAddress;
  //   } catch (e) {
  //     return <div>No Beneficiary Details</div>;
  //   }
  // };

  const formatBeneficiaryAddress = useCallback((address: string) => {
    try {
      const parsedAddress = JSON.parse(address);

      const formattedAddress = Object.keys(parsedAddress).map((key, index) => (
        <div key={`${key}-${index}`}>
          <strong>
            {key
              .replace(/([A-Z])/g, ' $1')
              .replace(/^./, (str) => str.toUpperCase())}
            :
          </strong>{' '}
          {parsedAddress[key] || 'NA'}
        </div>
      ));

      return <>{formattedAddress}</>;
    } catch (e) {
      return <div>No Beneficiary Details</div>;
    }
  }, []);

  const columns: ColumnsType<DataType> = [
    // {
    //     title: "Time Type",
    //     render: (record) => (
    //         <React.Fragment>
    //             {record.modified}
    //             <br />
    //             {record.modified}
    //         </React.Fragment>
    //     ),
    //     responsive: ["xs"]
    // },
    // {
    //     title: "Amount",
    //     render: (record) => (
    //         <React.Fragment>
    //             {record.amount}

    //             {record.currencyRef}
    //         </React.Fragment>
    //     ),
    //     // responsive: ["xs"]
    // },
    {
      title: 'Time',
      dataIndex: 'txDate',
      key: 'txDate',
      render: (text) => (
        <span>{moment(text).format('MM/DD/YYYY hh:mm:ss a')}</span>
      ),
      // responsive: ["sm"],
    },
    {
      title: 'Asset',
      dataIndex: 'currencyRef',
      key: 'currencyRef',
      render: (text) => <span>{text}</span>,
      // responsive: ["sm"],
    },
    {
      title: 'Type',
      dataIndex: 'transactionType',
      key: 'transactionType',
      // responsive: ["sm"]
    },
    {
      title: 'Deposit Wallet',
      dataIndex: 'walletType',
      key: 'walletType',
      render: (text) => <span>{text}</span>,
      // responsive: ["sm"],
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
      // responsive: ["sm"],
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      // responsive: ["sm"],
    },
    {
      title: 'Beneficiary Details',
      key: 'benificaryAddress',
      render: (_, record) => (
        <span>{formatBeneficiaryAddress(record.benificaryAddress)}</span>
      ),
      // responsive: ["sm"],
    },
    {
      title: 'Payment Receipt',
      key: 'txId',
      render: (_, record) => (
        <span>
          {/* {record.txId} */}
          {/* {ShortenText(record.txId, 0, 20) + "..."} */}
          {record.txId && record.txId.length > 20
            ? ShortenText(record.txId, 0, 20) + '...'
            : record.txId || 'N/A'}
          <span>
            <Tooltip title="Click to copy"></Tooltip>
            <CopyOutlined
              className="padding-lr-1x hover_icon"
              onClick={() => copy(record.txId || '')}
            />
            {/* <LinkOutlined /> */}
          </span>
        </span>
      ),
      // responsive: ["sm"],
    },
    {
      title: 'Destination',
      key: 'to',
      render: (_, record) => {
        const isJsonObject = (str: any) => {
          try {
            const json = JSON.parse(str);
            return json && typeof json === 'object';
          } catch (e) {
            return false;
          }
        };
        const formatText = (text: any) => {
          return text && text.length > 20
            ? ShortenText(text, 0, 20) + '...'
            : text || 'N/A';
        };
        console.log(isJsonObject(record.to));
        const displayContent = isJsonObject(record.to) ? (
          <span>{formatBeneficiaryAddress(record.to)}</span>
        ) : (
          <span>{formatText(record.to)}</span>
        );

        return (
          <span>
            {displayContent}
            <span>
              <CopyOutlined
                className="padding-lr-1x hover_icon"
                onClick={() => copy(record.to || '')}
              />
            </span>
          </span>
        );
      },
      // responsive: ["sm"],
    },
    {
      title: 'Notes',
      key: 'notes',
      dataIndex: 'notes',
      render: (text) => (text ? <span title={text}>{text}</span> : null),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          console.error('No access token found');
          return;
        }

        const decodedToken: any = decodeJWT(String(token)) as any;
        if (!decodedToken?.email) {
          console.error('Invalid token or missing email');
          return;
        }

        const res = await transactionList(decodedToken.email);
        if (!res?.data || !Array.isArray(res.data)) {
          console.error('Invalid response data');
          return;
        }

        const results = res.data;
        let finalArr = [];
        for (let i = 0; i < results.length; i++) {
          if (results[i].transactionType?.includes('FIAT')) {
            finalArr.push(results[i]);
          }
        }

        const uniqueTypes = new Set();
        const uniqueAssets = new Set();

        finalArr.forEach((transaction: any) => {
          if (transaction.transactionType) {
            uniqueTypes.add(transaction.transactionType);
          }
          if (transaction.currencyRef) {
            uniqueAssets.add(transaction.currencyRef);
          }
        });

        setTransactionTypes(Array.from(uniqueTypes) as string[]);
        setAssets(Array.from(uniqueAssets) as string[]);

        // Sort transactions by time in descending order
        finalArr.sort(
          (a, b) => moment(b.txDate).valueOf() - moment(a.txDate).valueOf()
        );
        setTxList(finalArr);
        setTxListFilter(finalArr);
      } catch (error) {
        console.error('Error fetching transaction data:', error);
        setTxList([]);
        setTxListFilter([]);
      }
    };

    fetchData();
  }, []);

  // Notify parent component when filtered data changes
  useEffect(() => {
    if (onDataChange && txListFilter) {
      onDataChange(txListFilter);
    }
  }, [txListFilter, onDataChange]);

  // const handleChangeTime0 = (value: string) => {
  //   const pastDate = moment().subtract(+value, 'days').format('YYYY-MM-DD');
  //   if (!isNaN(+value)) {
  //     setSelection({
  //       type: selection.type,
  //       asset: selection.asset,
  //       status: selection.status,
  //       time: value,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.txDate).format('YYYY-MM-DD');
  //       return (
  //         moment(pastDate).isSameOrBefore(valueDate) &&
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   } else {
  //     setSelection({
  //       type: selection.type,
  //       asset: selection.asset,
  //       status: selection.status,
  //       time: '',
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       return (
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   }
  // };

  const handleChangeTime = (el: any) => {
    const value = el.target.value;
    setSelection((prevSelection) => ({
      ...prevSelection,
      time: value,
    }));

    // Apply the filter after the type is changed
    filterTransactions({
      ...selection,
      time: value,
    });
  };

  // const handleChangeStatus0 = (value: string) => {
  //   const pastDate = moment()
  //     .subtract(+selection.time, 'days')
  //     .format('YYYY-MM-DD');

  //   if (value !== 'all') {
  //     setSelection({
  //       type: selection.type,
  //       asset: selection.asset,
  //       status: value,
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');

  //       return (
  //         data.status?.toLowerCase() === value?.toLowerCase() &&
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   } else {
  //     setSelection({
  //       type: selection.type,
  //       asset: selection.asset,
  //       status: '',
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');

  //       return (
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   }
  // };

  const handleChangeStatus = (el: any) => {
    const value = el.target.value;
    setSelection((prevSelection) => ({
      ...prevSelection,
      status: value,
    }));

    // Apply the filter after the type is changed
    filterTransactions({
      ...selection,
      status: value,
    });
  };

  // const handleChangeType0 = (value: string) => {
  //   const pastDate = moment()
  //     .subtract(+selection.time, 'days')
  //     .format('YYYY-MM-DD');

  //   if (value !== 'all') {
  //     setSelection({
  //       type: value,
  //       asset: selection.asset,
  //       status: selection.status,
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');
  //       // && data.currencyRef?.toLowerCase() === value?.toLowerCase()
  //       return (
  //         data.transactionType?.toLowerCase() === value?.toLowerCase() &&
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);

  //     // WITHDRAW_CYRPTO WITHDRAW_CRYPTO
  //   } else {
  //     setSelection({
  //       type: '',
  //       asset: selection.asset,
  //       status: selection.status,
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');
  //       // && data.currencyRef?.toLowerCase() === value?.toLowerCase()
  //       return (
  //         (!selection.asset ||
  //           data.currencyRef?.toLowerCase() ===
  //             selection.asset?.toLowerCase()) &&
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   }
  // };

  const handleChangeType = (el: any) => {
    const value = el.target.value;
    setSelection((prevSelection) => ({
      ...prevSelection,
      type: value,
    }));

    // Apply the filter after the type is changed
    filterTransactions({
      ...selection,
      type: value,
    });
  };

  // const handleChangeAsset0 = (value: string) => {
  //   const pastDate = moment()
  //     .subtract(+selection.time, 'days')
  //     .format('YYYY-MM-DD');
  //   if (value !== 'all') {
  //     setSelection({
  //       type: selection.type,
  //       asset: value,
  //       status: selection.status,
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');

  //       return (
  //         data.currencyRef?.toLowerCase() === value?.toLowerCase() &&
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   } else {
  //     setSelection({
  //       type: selection.type,
  //       asset: '',
  //       status: selection.status,
  //       time: selection.time,
  //       transactionHash: selection.transactionHash,
  //     });
  //     const txListFilterData = txList.filter((data: any) => {
  //       let valueDate = moment(data.created).format('YYYY-MM-DD');

  //       return (
  //         (!selection.time || moment(pastDate).isSameOrBefore(valueDate)) &&
  //         (!selection.type ||
  //           data.transactionType?.toLowerCase() ===
  //             selection.type?.toLowerCase()) &&
  //         (!selection.status ||
  //           data.status?.toLowerCase() === selection.status?.toLowerCase()) &&
  //         (!selection.transactionHash ||
  //           data.txId
  //             ?.toLowerCase()
  //             .includes(selection.transactionHash?.toLowerCase()))
  //       );
  //     });
  //     setTxListFilter(txListFilterData);
  //   }
  // };

  const handleChangeAsset = (el: any) => {
    const value = el.target.value;
    setSelection((prevSelection) => ({
      ...prevSelection,
      asset: value, // Correctly updating the asset field, not type
    }));

    // Apply the filter after the asset is changed
    filterTransactions({
      ...selection,
      asset: value,
    });
  };

  const filterTransactions = (filterCriteria: any) => {
    if (!txList || !Array.isArray(txList)) {
      setTxListFilter([]);
      return;
    }

    const filteredData = txList.filter((data: any) => {
      if (!data) return false;

      const pastDate =
        filterCriteria.time !== 'all'
          ? moment().subtract(+filterCriteria.time, 'days').format('YYYY-MM-DD')
          : null;
      const valueDate = moment(data.created || data.txDate).format(
        'YYYY-MM-DD'
      );

      // Filter conditions based on the selected criteria
      const assetMatches =
        filterCriteria.asset === 'all' ||
        data.currencyRef?.toLowerCase() === filterCriteria.asset?.toLowerCase();

      const timeMatches =
        filterCriteria.time === 'all' ||
        (pastDate && moment(pastDate).isSameOrBefore(valueDate));

      const typeMatches =
        filterCriteria.type === 'all' ||
        data.transactionType?.toLowerCase() ===
          filterCriteria.type?.toLowerCase();

      const statusMatches =
        filterCriteria.status === 'all' ||
        data.status?.toLowerCase() === filterCriteria.status?.toLowerCase();

      const txHashMatches =
        !filterCriteria.transactionHash ||
        data.txId
          ?.toLowerCase()
          .includes(filterCriteria.transactionHash?.toLowerCase());

      return (
        assetMatches &&
        timeMatches &&
        typeMatches &&
        statusMatches &&
        txHashMatches
      );
    });

    console.log('filteredData', filteredData); // Debugging filtered results
    setTxListFilter(filteredData);
  };

  const onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    // setValueInput(searchValue);

    // Update the search in the selection state
    setSelection((prevSelection) => ({
      ...prevSelection,
      transactionHash: searchValue,
    }));

    // Apply the filter after updating the search value
    filterTransactions({
      ...selection,
      transactionHash: searchValue,
    });
  };

  // const handleSearchHashId = (value: string) => {
  //   const txListFilterData = txList.filter((data: any) => {
  //     return data.txId?.toLowerCase() === value?.toLowerCase();
  //   });
  //   setTxListFilter(txListFilterData);
  // };
  // const handleSearch = (value: string) => {
  //   let res: { value: string; label: string }[] = [];
  //   if (!value || value.indexOf('@') >= 0) {
  //     res = [];
  //   } else {
  //     res = txList.map((data: any) => ({
  //       value: data.txId,
  //       label: `${data.txId}`,
  //     }));
  //   }
  //   setOptions(res);
  // };
  const getData = useCallback(
    (current: number, pageSize: number) => {
      if (!txListFilter || !Array.isArray(txListFilter)) {
        return [];
      }
      const xx = txListFilter.slice(
        (current - 1) * pageSize,
        current * pageSize
      );
      return xx;
    },
    [txListFilter]
  );
  const MyPagination = useMemo(
    () =>
      ({ total, onChange, current }: any) => {
        return (
          <Pagination
            onChange={onChange}
            total={total}
            current={current}
            pageSize={pageSize}
            responsive={true}
            style={{
              padding: '5px',
              textAlign: 'center',
            }}
          />
        );
      },
    [pageSize]
  );
  return (
    <div className="flex-align-stretch bs_main width-100  margin-t-3x padding-t-2x ">
      <div className="d-flex transaction_filters margin-b-3x">
        <div className="filter-item">
          <label>Type</label> <br />
          <CustomSelectBox
            // items={[
            //   { name: 'All', value: 'all' },
            //   { name: 'Deposit', value: 'DEPOSIT_CYRPTO' },
            //   { name: 'Withdraw', value: 'WITHDRAW_CRYPTO' },
            //   { name: 'Reward Withdraw', value: 'WITHDRAW_REWARDS' },
            // ]}
            items={transactionTypes.map((type) => ({
              name: type,
              value: type,
            }))}
            value={selection.type}
            onChange={handleChangeType}
            hasborder
            type={undefined}
            isCurrency={undefined}
            onCurrencyChange={undefined}
          />
          {/* <Select defaultValue="all" onChange={handleChangeType}>
            <Option value="all">All</Option>
            <Option value="DEPOSIT_FIAT">Deposit</Option>
            <Option value="WITHDRAW_FIAT">Withdraw</Option>
          </Select> */}
        </div>
        <div className="filter-item">
          <label>Time</label> <br />
          <CustomSelectBox
            items={[
              { name: 'All', value: 'all' },
              { name: 'Past 7 days', value: '7' },
              { name: 'Past 30 days', value: '30' },
              { name: 'Past 90 days', value: '90' },
            ]}
            value={selection.time}
            onChange={handleChangeTime}
            hasborder
            type={undefined}
            isCurrency={undefined}
            onCurrencyChange={undefined}
          />
          {/* <Select defaultValue="30" onChange={handleChangeTime}>
            <Option value="all">All</Option>
            <Option value="7">Past 7 days</Option>
            <Option value="30">Past 30 days</Option>
            <Option value="90">Past 90 days</Option>
          </Select> */}
        </div>
        <div className="filter-item">
          <label>Asset</label> <br />
          <CustomSelectBox
            // items={[
            //   { name: 'All', value: 'all' },

            //   { name: 'USD', value: 'USD' },
            // ]}
            items={assets.map((type) => ({ name: type, value: type }))}
            value={selection.asset}
            onChange={handleChangeAsset}
            hasborder
            type={undefined}
            isCurrency={undefined}
            onCurrencyChange={undefined}
          />
          {/* <Select defaultValue="all" onChange={handleChangeAsset}>
            <Option value="all">All</Option>
            <Option value="USD">USD</Option>
          </Select> */}
        </div>
        <div className="filter-item">
          <label>Status</label> <br />
          <CustomSelectBox
            items={[
              { name: 'All', value: 'all' },
              { name: 'Completed', value: 'Completed' },
              { name: 'Pending', value: 'Pending' },
            ]}
            value={selection.status}
            onChange={handleChangeStatus}
            hasborder
            type={undefined}
            isCurrency={undefined}
            onCurrencyChange={undefined}
          />
          {/* <Select defaultValue="all" onChange={handleChangeStatus}>
            <Option value="all">All</Option>
            <Option value="completed">Completed</Option>
            <Option value="pending">Pending</Option>
          </Select> */}
        </div>
        <div className="filter-item">
          <label>Transaction Hash</label> <br />
          <InputField
            size="large"
            placeholder="Search Transaction hash"
            style={{ height: '55px', marginTop: '0px' }}
            value={selection.transactionHash}
            onChange={onChangeSearch}
            maxLength={50}
            type={undefined}
            label={undefined}
            defaultValue={undefined}
            id={undefined}
            startAdornment={undefined}
            endAdornment={undefined}
            className={undefined}
            helperText={undefined}
            error={undefined}
            secondaryLabel={undefined}
            rows={undefined}
            yellowBorders={undefined}
            blueBorders={undefined}
          />
          {/* <AutoComplete
            onSearch={handleSearch}
            placeholder="Search transaction id"
            onSelect={handleSearchHashId}
            options={options}
            allowClear={true}
          /> */}
        </div>
        <div className="filter-item">
          <Button
            style={{
              background: 'transparent',
              border: 'none',
              color: theme.palette.text.primary,
              fontSize: '16px',
              width: 'fit-content',
              marginBottom: '10px',
            }}
            onClick={() => {
              setSelection({
                type: 'all',
                asset: 'all',
                status: 'all',
                time: 'all',
                transactionHash: '',
              });
              // Reset the filtered transaction list to show all data
              setTxListFilter(txList); // Reset to the full list of transactions
            }}
          >
            Reset
          </Button>
        </div>
      </div>
      <Table
        pagination={false}
        columns={columns}
        dataSource={getData(current, pageSize)?.map((item, index) => ({
          ...item,
          key: item.txId || `row-${index}`,
        }))}
        // className="transaction_crypto_history"
        className="custom_table"
        scroll={{ x: true }}
        style={{ maxWidth: '94vw' }}
      />
      <MyPagination
        total={txListFilter?.length || 0}
        current={current}
        onChange={setCurrent}
      />
    </div>
  );
};

export default BSTransactionHistoryTable;
